var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "advisor-search-result",
      attrs: { role: "group", "aria-label": "advisor" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "advisor-row" }, [
          _c("div", { staticClass: "advisor-image" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.selectedAdvisorClick(_vm.advisor, "image")
                  }
                }
              },
              [
                _c("img", {
                  staticStyle: { width: "125px" },
                  attrs: {
                    alt: _vm.advisor.firstName + " " + _vm.advisor.lastName,
                    src: _vm.advisor.image
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "advisor-name" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.selectedAdvisorClick(_vm.advisor, "name")
                  }
                }
              },
              [
                _c("h2", { staticClass: "h5" }, [
                  _vm._v(
                    _vm._s(_vm.advisor.firstName) +
                      " " +
                      _vm._s(_vm.advisor.lastName)
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.advisor.advisorTitle
              ? _c("p", [_vm._v(_vm._s(_vm.advisor.advisorTitle))])
              : _vm._e(),
            _vm._v(" "),
            _vm.advisor.nmlsNumber
              ? _c("p", [
                  _vm._v(
                    _vm._s(_vm.text("nmls")) +
                      " #" +
                      _vm._s(_vm.advisor.nmlsNumber)
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          !_vm.isDirectConsumer
            ? _c("div", {
                staticClass: "advisor-branch",
                domProps: { innerHTML: _vm._s(_vm.address) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "advisor-distance" }, [
            _vm.advisor.distance > 0
              ? _c("div", { staticClass: "advisor-distance-wrap" }, [
                  _c("p", [_vm._v(_vm._s(_vm.distance))])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "advisor-caret" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.selectedAdvisorClick(_vm.advisor, "arrow")
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "bi bi-chevron-right",
                    attrs: {
                      role: "img",
                      "aria-labelledby": _vm.advisor.id,
                      width: "2em",
                      height: "2em",
                      viewBox: "0 0 16 16",
                      fill: "currentColor",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("title", { attrs: { id: _vm.advisor.id } }, [
                      _vm._v(
                        _vm._s(_vm.advisor.firstName) +
                          " " +
                          _vm._s(_vm.advisor.lastName) +
                          " Details"
                      )
                    ]),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        d:
                          "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }